import MUIIconButton, { IconButtonProps } from "@mui/material/IconButton";
import React, { FC } from "react";

export const IconButton: FC<IconButtonProps> = (props) => (
  <MUIIconButton {...props} />
);
